module.exports = __webpack_public_path__ + "img/reference51.9b74dfba.jpg";